// extracted by mini-css-extract-plugin
module.exports = {"calendar":"Datablock_Calendar_calendar__596DY"};